import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/users/actions";
import {
  form,
  Form as AppForm,
  LargeInput as FormInput
} from "MODULES/shared/components/Forms";
import AdminFields from "MODULES/users/components/Admin";
import ReduxFormLocationDropdown from "MODULES/Locations/components/ReduxFormLocationsDropdown";
import validate from "./validate";

const formName = "createUser";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <div className="row row-col-gutters-half">
          <div className="col-md-6">
            <Field
              name="first_name"
              component={FormInput}
              label="First Name"
              required
            />
          </div>
          <div className="col-md-6">
            <Field
              name="last_name"
              component={FormInput}
              label="Last Name"
              required
            />
          </div>
        </div>
        <Field name="email" component={FormInput} label="Email" required />
        <div className="row row-col-gutters-half">
          <div className="col-md-6">
            <Field
              name="password"
              component={FormInput}
              type="password"
              label="Password"
              required
            />
          </div>
          <div className="col-md-6">
            <Field
              name="confirm"
              component={FormInput}
              type="password"
              label="Retype Password"
              required
            />
          </div>
        </div>
        <ReduxFormLocationDropdown required />
        <AdminFields isNew formName={formName} />
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, { onSubmit: actions.create })(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/users/components/CreateUser/Form.jsx